import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.services": "Services",
      "nav.features": "Features",
      "nav.privacy": "Privacy",
      "nav.tagline": "Community Resource Hub",
      "nav.closeMenu": "Close menu",
      "nav.openMenu": "Open menu",
      "nav.goHome": "Go to Oasis Oakland home",

      // Hero Section
      "hero.title": "Connecting you with essential",
      "hero.titleHighlight": "community services",
      "hero.subtitle": "Access free and affordable healthcare, food, education, and more in Oakland. No login required, available in 3 languages.",
      "hero.ctaGooglePlay": "Coming Soon to Google Play",
      "hero.ctaAppStore": "App Store (Coming Later)",
      "hero.googlePlayLabel": "Download now",
      "hero.googlePlayStore": "on Google Play",
      "hero.badgeFree": "100% Free",
      "hero.badgeNoLogin": "No Login Required",
      "hero.badgeLanguages": "3 Languages",
      "hero.notifyButton": "Get notified when we launch",
      "hero.floatingHealth": "Health",
      "hero.floatingFood": "Food",
      "hero.floatingEducation": "Education",
      "hero.imageAlt": "Oasis Oakland - Community Resources",

      // Mission Section
      "mission.title": "Our Mission",
      "mission.text": "We make essential services accessible for everyone in Oakland and Alameda County. Looking for free healthcare, affordable dental care, food assistance, insurance support, or literacy programs? Our app connects you to trusted local resources in one place. No logins, no confusion. Just real help, fast.",

      // What is Oasis Section
      "what.badge": "About the App",
      "what.title": "What is Oasis Oakland?",
      "what.subtitle": "Find verified community support fast, in your language",
      "what.description": "Oasis Oakland is an independent, multilingual app that spotlights 24+ trusted services for health, food, education, insurance, and dental care across Oakland and Alameda County. We keep details current so you can reach help without creating accounts or paying fees.",

      "what.solutionTitle": "Inside the app",
      "what.solution1": "Browse a single directory with location, category, and eligibility guidance.",
      "what.solution2": "Switch instantly between English, Spanish, and Mandarin whenever you need.",
      "what.solution3": "Review hours, contact options, and what to bring before you visit.",

      "what.stat1": "Verified resources",
      "what.stat2": "Languages supported",
      "what.stat3": "Service categories",
      "what.stat4": "Always free",

      // Why Section
      "why.title": "Why Oakland Needs Oasis",
      "why.fragmented.title": "Fragmented Information",
      "why.fragmented.problem": "Resources are scattered across multiple websites, flyers, and phone lines",
      "why.fragmented.solution": "Oasis Solution:",
      "why.fragmented.answer": "Everything centralized in one app",
      "why.language.title": "Language Barriers",
      "why.language.problem": "Most official services are only available in English",
      "why.language.answer": "Full support in English, Spanish, and Mandarin",
      "why.complex.title": "Complex Navigation",
      "why.complex.problem": "Confusing bureaucratic systems that intimidate people",
      "why.complex.answer": "Simple interface, no jargon, no registration",

      // Services Section
      "services.title": "Services We Connect You To",
      "services.subtitle": "Trusted resources across 5 essential categories",
      "services.health.title": "Health",
      "services.health.item1": "Primary care, vaccinations, mental health",
      "services.health.item2": "Free and sliding-fee clinics",
      "services.health.item3": "Medi-Cal & Medicare assistance",
      "services.dental.title": "Dental",
      "services.dental.item1": "Cleanings, fillings, emergency dental",
      "services.dental.item2": "Pediatric dentistry",
      "services.dental.item3": "Sliding-fee options",
      "services.literacy.title": "Literacy",
      "services.literacy.item1": "ESL classes, GED prep",
      "services.literacy.item2": "Job training programs",
      "services.literacy.item3": "Digital literacy courses",
      "services.food.title": "Food",
      "services.food.item1": "Food banks & pantries",
      "services.food.item2": "Hot meal programs",
      "services.food.item3": "CalFresh (SNAP) enrollment",
      "services.insurance.title": "Insurance",
      "services.insurance.item1": "Covered California enrollment",
      "services.insurance.item2": "Medi-Cal assistance",
      "services.insurance.item3": "Plan comparison help",

      // Features Section (Bento Grid)
      "featuresSection.title": "Everything you need in one place",
      "featuresSection.subtitle": "From health clinics to legal aid, Oasis Oakland connects you with the services you need. Powered by the community, for the community.",
      "featuresSection.findResources.title": "Find Resources Easily",
      "featuresSection.findResources.desc": "Locate food pantries, shelters, health clinics, and legal aid services near you with our interactive map.",
      "featuresSection.verifiedLocations.title": "Verified Locations",
      "featuresSection.verifiedLocations.desc": "We verify every location to ensure you get accurate, up-to-date information.",
      "featuresSection.smartFiltering.title": "Smart Filtering",
      "featuresSection.smartFiltering.desc": "Quickly narrow down results by category, distance, and open status to find exactly what you need.",
      "featuresSection.alwaysAvailable.title": "Always Available",
      "featuresSection.alwaysAvailable.desc": "Access vital information 24/7. No login required, no barriers to entry.",

      // Features Section (Old)
      "features.title": "Key Features",
      "features.subtitle": "Built with you in mind",
      "features.noLogin.title": "No Login Required",
      "features.noLogin.desc": "Start finding help immediately. No account, no email, complete privacy.",
      "features.filtering.title": "Smart Filtering",
      "features.filtering.desc": "See only services you qualify for based on your income level",
      "features.hours.title": "Real-time Hours",
      "features.hours.desc": "Know if a place is open NOW before you visit",
      "features.maps.title": "Map & List Views",
      "features.maps.desc": "Find services near you with interactive maps",
      "features.call.title": "Call & Navigate",
      "features.call.desc": "One-tap calling and directions to any service",
      "features.favorites.title": "Save Favorites",
      "features.favorites.desc": "Bookmark services for quick access later",

      // How It Works Section
      "how.title": "How It Works",
      "how.subtitle": "Finding help shouldn't be complicated",
      "how.noLogin.title": "No Login Needed",
      "how.noLogin.desc": "Open the app and start finding resources right away — no account, no barriers",
      "how.hours.title": "See What's Open Now",
      "how.hours.desc": "Check real-time hours before you head out, so you don't waste a trip",
      "how.maps.title": "Map & List Views",
      "how.maps.desc": "Browse services on a map or list — whatever works best for you",
      "how.languages.title": "3 Languages",
      "how.languages.desc": "Switch between English, Spanish, and Mandarin instantly",

      // Who Section (Merged with Serving)
      "who.badge": "Oakland & Alameda County",
      "who.title": "Who We Serve",
      "who.subtitle": "We're here for everyone in our community, especially those who need it most",
      "who.item1": "Families looking for free or affordable healthcare, food, and education",
      "who.item2": "Spanish and Mandarin-speaking community members",
      "who.item3": "Seniors seeking Medicare info, meals, and health support",
      "who.item4": "Parents finding care and programs for their kids",
      "who.note": "Currently serving Oakland and Alameda County with plans to expand. Want Oasis in your city? Let us know!",

      // Serving Section (kept for backwards compatibility)
      "serving.badge": "Serving Oakland, CA",
      "serving.title": "Currently Serving Oakland",
      "serving.text1": "Oasis Oakland currently serves Oakland and Alameda County, California. We've carefully verified and mapped over 24 essential community resources across health, dental, food, education, and insurance services.",
      "serving.text2": "Coming Soon:",
      "serving.text3": "We're planning to expand to other cities in the Bay Area and beyond. If you'd like Oasis in your community, contact us!",

      // Languages Section
      "languages.title": "Available in 3 Languages",
      "languages.english": "English",
      "languages.spanish": "Español",
      "languages.mandarin": "中文 (Mandarin)",
      "languages.fullTranslation": "Full translation",
      "languages.note": "Switch languages instantly within the app. No restart needed.",

      // Newsletter Section
      "newsletter.title": "Oasis Oakland is Launching Soon!",
      "newsletter.googlePlay": "Google Play",
      "newsletter.googlePlayDesc": "Launching first",
      "newsletter.appStore": "App Store",
      "newsletter.appStoreDesc": "Coming after",
      "newsletter.subtitle": "Get notified when we launch on Google Play",
      "newsletter.placeholder": "Enter your email",
      "newsletter.button": "Notify Me",
      "newsletter.note": "We'll only email you once when the app is ready. No spam.",
      "newsletter.success": "🎉 Success! You're on the list.",
      "newsletter.successDesc": "We'll send you an email as soon as Oasis Oakland launches on Google Play. Thank you for your interest in helping the Oakland community!",
      "newsletter.error": "Oops! Something went wrong.",
      "newsletter.errorDesc": "Please try again in a moment. If the problem persists, contact us directly.",
      "newsletter.sending": "Sending...",

      // Beta Download Modal
      "modal.title": "Download Beta Version",
      "modal.chooseVersion": "Choose your version:",
      "modal.android": "Android",
      "modal.androidDesc": "Download from Google Play",
      "modal.web": "Web Beta",
      "modal.webDesc": "Try the web version",
      "modal.betaWarning": "These links only work if you're in the testers group",
      "modal.notInGroup": "Not in the group yet?",
      "modal.enterEmail": "Enter your email to join the beta testers",
      "modal.joinBeta": "Join Beta Program",
      "modal.close": "Close",
      "modal.emailPlaceholder": "Enter your email",
      "modal.submitting": "Sending...",
      "modal.successTitle": "Success!",
      "modal.successMessage": "We'll send you an email with instructions to join the beta program.",
      "modal.errorTitle": "Error",
      "modal.errorMessage": "Something went wrong. Please try again.",

      // Privacy Section
      "privacy.title": "Privacy Policy",
      "privacy.transparent": "Transparent",
      "privacy.transparentDesc": "Clear language about what we collect and why.",
      "privacy.localFirst": "Local-First",
      "privacy.localFirstDesc": "Your information never leaves your device without consent.",
      "privacy.empowering": "Empowering",
      "privacy.empoweringDesc": "Tools to review, update, or delete the data you share.",
      "privacy.intro": "Thank you for using Oasis Oakland, an app designed to connect you with essential community services in Oakland and Alameda County. Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our app.",

      "privacy.section1.title": "1. Information We Collect",
      "privacy.section1.intro": "We collect the following types of information to provide personalized service recommendations:",
      "privacy.section1.personal": "Personal Information:",
      "privacy.section1.personalDesc": "During the evaluation process, you may provide details such as your gender, employment status, income range, language preferences, and city of residence. This information is provided voluntarily and helps us tailor service options to your needs. This data never leaves the app and is used to provide services that better suit the user.",
      "privacy.section1.location": "Location Data:",
      "privacy.section1.locationDesc": "With your permission, we access your device's location to provide relevant nearby services and directions. This data is used locally within the app and is not stored or transmitted.",
      "privacy.section1.saved": "Saved Places:",
      "privacy.section1.savedDesc": "You can save places to your notes, which are stored locally on your device for your convenience.",
      "privacy.section1.outro": "All data is collected and stored locally on your device using secure local storage mechanisms. We do not collect or store sensitive information like payment details, as our app does not process transactions.",

      "privacy.section2.title": "2. How We Use Your Information",
      "privacy.section2.intro": "We use the information we collect solely to:",
      "privacy.section2.item1": "Provide personalized recommendations for community services based on your evaluation responses.",
      "privacy.section2.item2": "Enable location-based features, such as finding nearby services or getting directions.",
      "privacy.section2.item3": "Improve the app's functionality and user experience through anonymous analytics.",
      "privacy.section2.item4": "Allow you to save and manage notes about places.",
      "privacy.section2.outro": "We do not use your data for marketing, advertising, or any other purposes outside of app functionality.",

      "privacy.section3.title": "3. Sharing Your Information",
      "privacy.section3.text": "We do not share, sell, or transmit your personal information to third parties. All data remains on your device and is not sent to external servers or shared with other apps or services. However, if you choose to share a place via the app's sharing feature, that action is handled by your device's native sharing capabilities and is subject to the recipient's privacy practices.",

      "privacy.section4.title": "4. Data Security",
      "privacy.section4.intro": "We prioritize the security of your information:",
      "privacy.section4.item1": "Data is stored locally on your device using encrypted storage (e.g., AsyncStorage with Redux Persist).",
      "privacy.section4.item2": "We do not have access to your data; it resides solely on your device.",
      "privacy.section4.item3": "We recommend keeping your device secure with passcodes, biometric locks, and up-to-date software to protect your information.",

      "privacy.section5.title": "5. Your Rights",
      "privacy.section5.intro": "You have the following rights regarding your data:",
      "privacy.section5.access": "Access and Control:",
      "privacy.section5.accessDesc": "You can view, update, or delete your saved data (e.g., notes) directly within the app.",
      "privacy.section5.withdraw": "Withdraw Consent:",
      "privacy.section5.withdrawDesc": "You can disable location permissions at any time through your device settings.",
      "privacy.section5.deletion": "Data Deletion:",
      "privacy.section5.deletionDesc": "To delete all locally stored data, you can clear the app's data or reinstall the app.",
      "privacy.section5.outro": "If you have concerns, please contact us as outlined below.",

      "privacy.section6.title": "6. Children's Privacy",
      "privacy.section6.text": "Our app is not intended for children under 13. We do not knowingly collect personal information from children. If we become aware of such collection, we will delete it immediately.",

      "privacy.section7.title": "7. Changes to This Privacy Policy",
      "privacy.section7.text": "We may update this Privacy Policy occasionally to reflect changes in our practices or for legal reasons. We will notify you of significant changes by updating the effective date and, if necessary, prompting you within the app.",

      "privacy.section8.title": "8. Independent Service Disclaimer",
      "privacy.section8.intro": "Oasis Oakland operates as an independent community resource platform. We are not affiliated with, endorsed by, or formally associated with any of the organizations, healthcare providers, dental clinics, food banks, educational institutions, or insurance providers featured in our directory.",
      "privacy.section8.details": "Our role is to serve as an informational resource, connecting community members with publicly available services. All services listed are independently operated by their respective organizations. We verify information to the best of our ability, but service availability, eligibility requirements, and operating hours are ultimately determined by each individual provider.",
      "privacy.section8.responsibility": "Users should confirm details directly with service providers before visiting. Oasis Oakland is not responsible for the quality, availability, or outcomes of services provided by listed organizations.",

      "privacy.section9.title": "9. Contact Us",
      "privacy.section9.intro": "If you have any questions about this Privacy Policy or our data practices, please contact us at:",
      "privacy.section9.email": "Email:",

      "privacy.agreement": "By using Oasis Oakland, you agree to this Privacy Policy. If you do not agree, please discontinue use of the app.",

      // Footer
      "footer.about": "About",
      "footer.contact": "Contact",
      "footer.legal": "Legal",
      "footer.mission": "Our Mission",
      "footer.whoWeServe": "Who We Serve",
      "footer.privacyPolicy": "Privacy Policy",
      "footer.tagline": "Connecting you with essential community services",
      "footer.copyright": "2025 Oasis Oakland. All rights reserved.",
      "footer.madeWith": "Made with ❤️ for the Oakland community",
    }
  },
  es: {
    translation: {
      // Navegación
      "nav.home": "Inicio",
      "nav.services": "Servicios",
      "nav.features": "Características",
      "nav.privacy": "Privacidad",
      "nav.tagline": "Centro de Recursos Comunitarios",
      "nav.closeMenu": "Cerrar menú",
      "nav.openMenu": "Abrir menú",
      "nav.goHome": "Ir a inicio de Oasis Oakland",

      // Sección Hero
      "hero.title": "Conectándote con servicios",
      "hero.titleHighlight": "comunitarios esenciales",
      "hero.subtitle": "Accede a servicios gratuitos y asequibles de salud, alimentación, educación y más en Oakland. Sin registro, disponible en 3 idiomas.",
      "hero.ctaGooglePlay": "Próximamente en Google Play",
      "hero.ctaAppStore": "App Store (Próximamente)",
      "hero.googlePlayLabel": "Descargar ahora",
      "hero.googlePlayStore": "en Google Play",
      "hero.badgeFree": "100% Gratis",
      "hero.badgeNoLogin": "Sin Registro",
      "hero.badgeLanguages": "3 Idiomas",
      "hero.notifyButton": "Recibe notificación del lanzamiento",
      "hero.floatingHealth": "Salud",
      "hero.floatingFood": "Comida",
      "hero.floatingEducation": "Educación",
      "hero.imageAlt": "Oasis Oakland - Recursos Comunitarios",

      // Sección Misión
      "mission.title": "Nuestra Misión",
      "mission.text": "Hacemos que los servicios esenciales sean accesibles para todos en Oakland y el Condado de Alameda. ¿Buscas atención médica gratuita, cuidado dental asequible, asistencia alimentaria, apoyo con seguros o programas de alfabetización? Nuestra app te conecta con recursos locales confiables en un solo lugar. Sin registros, sin confusión. Solo ayuda real, rápida.",

      // Sección ¿Qué es Oasis?
      "what.badge": "Acerca de la App",
      "what.title": "¿Qué es Oasis Oakland?",
      "what.subtitle": "Encuentra recursos verificados en minutos y en tu idioma",
      "what.description": "Oasis Oakland es una app independiente y multilingüe que reúne más de 24 servicios confiables de salud, alimentación, educación, seguros y odontología en Oakland y el Condado de Alameda. Mantenemos la información al día para que llegues a la ayuda correcta sin crear cuentas ni pagar tarifas.",

      "what.solutionTitle": "Dentro de la app",
      "what.solution1": "Explora un único directorio con ubicación, categoría y orientación sobre elegibilidad.",
      "what.solution2": "Cambia de inmediato entre inglés, español y mandarín según lo necesites.",
      "what.solution3": "Revisa horarios, formas de contacto y qué llevar antes de visitar.",

      "what.stat1": "Recursos verificados",
      "what.stat2": "Idiomas disponibles",
      "what.stat3": "Categorías de servicio",
      "what.stat4": "Siempre gratis",

      // Sección Por Qué
      "why.title": "Por Qué Oakland Necesita Oasis",
      "why.fragmented.title": "Información Fragmentada",
      "why.fragmented.problem": "Los recursos están dispersos en múltiples sitios web, volantes y líneas telefónicas",
      "why.fragmented.solution": "Solución de Oasis:",
      "why.fragmented.answer": "Todo centralizado en una sola app",
      "why.language.title": "Barreras de Idioma",
      "why.language.problem": "La mayoría de servicios oficiales solo están disponibles en inglés",
      "why.language.answer": "Soporte completo en inglés, español y mandarín",
      "why.complex.title": "Navegación Compleja",
      "why.complex.problem": "Sistemas burocráticos confusos que intimidan a las personas",
      "why.complex.answer": "Interfaz simple, sin jerga, sin registro",

      // Sección Servicios
      "services.title": "Servicios a los que Te Conectamos",
      "services.subtitle": "Recursos confiables en 5 categorías esenciales",
      "services.health.title": "Salud",
      "services.health.item1": "Atención primaria, vacunas, salud mental",
      "services.health.item2": "Clínicas gratuitas y de tarifa reducida",
      "services.health.item3": "Asistencia con Medi-Cal y Medicare",
      "services.dental.title": "Dental",
      "services.dental.item1": "Limpiezas, empastes, emergencias dentales",
      "services.dental.item2": "Odontología pediátrica",
      "services.dental.item3": "Opciones de tarifa reducida",
      "services.literacy.title": "Alfabetización",
      "services.literacy.item1": "Clases de ESL, preparación para GED",
      "services.literacy.item2": "Programas de capacitación laboral",
      "services.literacy.item3": "Cursos de alfabetización digital",
      "services.food.title": "Alimentación",
      "services.food.item1": "Bancos de alimentos y despensas",
      "services.food.item2": "Programas de comidas calientes",
      "services.food.item3": "Inscripción en CalFresh (SNAP)",
      "services.insurance.title": "Seguros",
      "services.insurance.item1": "Inscripción en Covered California",
      "services.insurance.item2": "Asistencia con Medi-Cal",
      "services.insurance.item3": "Ayuda comparando planes",

      // Sección Características (Bento Grid)
      "featuresSection.title": "Todo lo que necesitas en un solo lugar",
      "featuresSection.subtitle": "Desde clínicas de salud hasta asistencia legal, Oasis Oakland te conecta con los servicios que necesitas. Impulsado por la comunidad, para la comunidad.",
      "featuresSection.findResources.title": "Encuentra Recursos Fácilmente",
      "featuresSection.findResources.desc": "Localiza bancos de alimentos, refugios, clínicas de salud y servicios de asistencia legal cerca de ti con nuestro mapa interactivo.",
      "featuresSection.verifiedLocations.title": "Ubicaciones Verificadas",
      "featuresSection.verifiedLocations.desc": "Verificamos cada ubicación para asegurar que obtengas información precisa y actualizada.",
      "featuresSection.smartFiltering.title": "Filtrado Inteligente",
      "featuresSection.smartFiltering.desc": "Reduce rápidamente los resultados por categoría, distancia y horario de apertura para encontrar exactamente lo que necesitas.",
      "featuresSection.alwaysAvailable.title": "Siempre Disponible",
      "featuresSection.alwaysAvailable.desc": "Accede a información vital las 24 horas del día, los 7 días de la semana. Sin registro requerido, sin barreras de entrada.",

      // Sección Características (Antiguo)
      "features.title": "Características Principales",
      "features.subtitle": "Diseñado pensando en ti",
      "features.noLogin.title": "Sin Registro Necesario",
      "features.noLogin.desc": "Encuentra ayuda de inmediato. Sin cuenta, sin correo, privacidad total.",
      "features.filtering.title": "Filtrado Inteligente",
      "features.filtering.desc": "Ve solo los servicios para los que calificas según tu nivel de ingresos",
      "features.hours.title": "Horarios en Tiempo Real",
      "features.hours.desc": "Sabe si un lugar está abierto AHORA antes de visitarlo",
      "features.maps.title": "Vistas de Mapa y Lista",
      "features.maps.desc": "Encuentra servicios cerca de ti con mapas interactivos",
      "features.call.title": "Llamar y Navegar",
      "features.call.desc": "Llama y obtén direcciones con un solo toque",
      "features.favorites.title": "Guardar Favoritos",
      "features.favorites.desc": "Marca servicios para acceso rápido después",

      // Sección Cómo Funciona
      "how.title": "Cómo Funciona",
      "how.subtitle": "Buscar ayuda no debería ser complicado",
      "how.noLogin.title": "Sin Registro",
      "how.noLogin.desc": "Abre la app y comienza a buscar recursos de inmediato — sin cuenta, sin barreras",
      "how.hours.title": "Ve Qué Está Abierto Ahora",
      "how.hours.desc": "Revisa los horarios en tiempo real antes de salir, para que no pierdas el viaje",
      "how.maps.title": "Vistas de Mapa y Lista",
      "how.maps.desc": "Explora servicios en un mapa o lista — lo que funcione mejor para ti",
      "how.languages.title": "3 Idiomas",
      "how.languages.desc": "Cambia entre inglés, español y mandarín al instante",

      // Sección A Quién Servimos (Combinada con Cobertura)
      "who.badge": "Oakland y Condado de Alameda",
      "who.title": "A Quién Servimos",
      "who.subtitle": "Estamos aquí para toda nuestra comunidad, especialmente para quienes más lo necesitan",
      "who.item1": "Familias que buscan salud, alimentación y educación gratuita o asequible",
      "who.item2": "Miembros de la comunidad de habla hispana y mandarín",
      "who.item3": "Personas mayores que buscan info de Medicare, comidas y apoyo de salud",
      "who.item4": "Padres que buscan cuidado y programas para sus hijos",
      "who.note": "Actualmente sirviendo a Oakland y el Condado de Alameda con planes de expansión. ¿Quieres Oasis en tu ciudad? ¡Avísanos!",

      // Sección Cobertura (mantenida para compatibilidad)
      "serving.badge": "Sirviendo a Oakland, CA",
      "serving.title": "Actualmente Sirviendo a Oakland",
      "serving.text1": "Oasis Oakland actualmente sirve a Oakland y el Condado de Alameda, California. Hemos verificado y mapeado cuidadosamente más de 24 recursos comunitarios esenciales en salud, dental, alimentación, educación y seguros.",
      "serving.text2": "Próximamente:",
      "serving.text3": "Planeamos expandirnos a otras ciudades del Área de la Bahía y más allá. ¡Si quieres Oasis en tu comunidad, contáctanos!",

      // Sección Idiomas
      "languages.title": "Disponible en 3 Idiomas",
      "languages.english": "Inglés",
      "languages.spanish": "Español",
      "languages.mandarin": "中文 (Mandarín)",
      "languages.fullTranslation": "Traducción completa",
      "languages.note": "Cambia de idioma instantáneamente en la app. Sin necesidad de reiniciar.",

      // Sección Newsletter
      "newsletter.title": "¡Oasis Oakland se Lanza Pronto!",
      "newsletter.googlePlay": "Google Play",
      "newsletter.googlePlayDesc": "Se lanza primero",
      "newsletter.appStore": "App Store",
      "newsletter.appStoreDesc": "Próximamente después",
      "newsletter.subtitle": "Recibe notificación cuando lancemos en Google Play",
      "newsletter.placeholder": "Ingresa tu correo",
      "newsletter.button": "Notificarme",
      "newsletter.note": "Solo te enviaremos un correo cuando la app esté lista. Sin spam.",
      "newsletter.success": "🎉 ¡Éxito! Estás en la lista.",
      "newsletter.successDesc": "Te enviaremos un correo tan pronto como Oasis Oakland se lance en Google Play. ¡Gracias por tu interés en ayudar a la comunidad de Oakland!",
      "newsletter.error": "¡Ups! Algo salió mal.",
      "newsletter.errorDesc": "Por favor intenta nuevamente en un momento. Si el problema persiste, contáctanos directamente.",
      "newsletter.sending": "Enviando...",

      // Modal de Descarga Beta
      "modal.title": "Descarga la Versión Beta",
      "modal.chooseVersion": "Elige tu versión:",
      "modal.android": "Android",
      "modal.androidDesc": "Descarga desde Google Play",
      "modal.web": "Web Beta",
      "modal.webDesc": "Prueba la versión web",
      "modal.betaWarning": "Estos enlaces solo funcionan si estás en el grupo de testers",
      "modal.notInGroup": "¿Aún no estás en el grupo?",
      "modal.enterEmail": "Ingresa tu correo para unirte a los beta testers",
      "modal.joinBeta": "Unirme al Programa Beta",
      "modal.close": "Cerrar",
      "modal.emailPlaceholder": "Ingresa tu correo",
      "modal.submitting": "Enviando...",
      "modal.successTitle": "¡Éxito!",
      "modal.successMessage": "Te enviaremos un correo con instrucciones para unirte al programa beta.",
      "modal.errorTitle": "Error",
      "modal.errorMessage": "Algo salió mal. Por favor intenta nuevamente.",

      // Sección Privacidad
      "privacy.title": "Política de Privacidad",
      "privacy.transparent": "Transparente",
      "privacy.transparentDesc": "Lenguaje claro sobre lo que recopilamos y por qué.",
      "privacy.localFirst": "Local Primero",
      "privacy.localFirstDesc": "Tu información nunca sale de tu dispositivo sin consentimiento.",
      "privacy.empowering": "Empoderante",
      "privacy.empoweringDesc": "Herramientas para revisar, actualizar o eliminar los datos que compartes.",
      "privacy.intro": "Gracias por usar Oasis Oakland, una aplicación diseñada para conectarte con servicios comunitarios esenciales en Oakland y el Condado de Alameda. Tu privacidad es importante para nosotros. Esta Política de Privacidad explica cómo recopilamos, usamos y protegemos tu información cuando usas nuestra app.",

      "privacy.section1.title": "1. Información que Recopilamos",
      "privacy.section1.intro": "Recopilamos los siguientes tipos de información para proporcionar recomendaciones de servicios personalizadas:",
      "privacy.section1.personal": "Información Personal:",
      "privacy.section1.personalDesc": "Durante el proceso de evaluación, puedes proporcionar detalles como tu género, estado laboral, rango de ingresos, preferencias de idioma y ciudad de residencia. Esta información se proporciona voluntariamente y nos ayuda a adaptar las opciones de servicio a tus necesidades. Estos datos nunca salen de la app y se usan para proporcionar servicios que se adapten mejor al usuario.",
      "privacy.section1.location": "Datos de Ubicación:",
      "privacy.section1.locationDesc": "Con tu permiso, accedemos a la ubicación de tu dispositivo para proporcionar servicios cercanos relevantes y direcciones. Estos datos se usan localmente dentro de la app y no se almacenan ni transmiten.",
      "privacy.section1.saved": "Lugares Guardados:",
      "privacy.section1.savedDesc": "Puedes guardar lugares en tus notas, que se almacenan localmente en tu dispositivo para tu conveniencia.",
      "privacy.section1.outro": "Todos los datos se recopilan y almacenan localmente en tu dispositivo usando mecanismos de almacenamiento local seguros. No recopilamos ni almacenamos información sensible como detalles de pago, ya que nuestra app no procesa transacciones.",

      "privacy.section2.title": "2. Cómo Usamos Tu Información",
      "privacy.section2.intro": "Usamos la información que recopilamos únicamente para:",
      "privacy.section2.item1": "Proporcionar recomendaciones personalizadas de servicios comunitarios basadas en tus respuestas de evaluación.",
      "privacy.section2.item2": "Habilitar funciones basadas en ubicación, como encontrar servicios cercanos u obtener direcciones.",
      "privacy.section2.item3": "Mejorar la funcionalidad de la app y la experiencia del usuario a través de análisis anónimos.",
      "privacy.section2.item4": "Permitirte guardar y gestionar notas sobre lugares.",
      "privacy.section2.outro": "No usamos tus datos para marketing, publicidad o cualquier otro propósito fuera de la funcionalidad de la app.",

      "privacy.section3.title": "3. Compartir Tu Información",
      "privacy.section3.text": "No compartimos, vendemos ni transmitimos tu información personal a terceros. Todos los datos permanecen en tu dispositivo y no se envían a servidores externos ni se comparten con otras apps o servicios. Sin embargo, si eliges compartir un lugar a través de la función de compartir de la app, esa acción es manejada por las capacidades nativas de compartir de tu dispositivo y está sujeta a las prácticas de privacidad del destinatario.",

      "privacy.section4.title": "4. Seguridad de Datos",
      "privacy.section4.intro": "Priorizamos la seguridad de tu información:",
      "privacy.section4.item1": "Los datos se almacenan localmente en tu dispositivo usando almacenamiento encriptado (ej. AsyncStorage con Redux Persist).",
      "privacy.section4.item2": "No tenemos acceso a tus datos; residen únicamente en tu dispositivo.",
      "privacy.section4.item3": "Recomendamos mantener tu dispositivo seguro con códigos de acceso, bloqueos biométricos y software actualizado para proteger tu información.",

      "privacy.section5.title": "5. Tus Derechos",
      "privacy.section5.intro": "Tienes los siguientes derechos con respecto a tus datos:",
      "privacy.section5.access": "Acceso y Control:",
      "privacy.section5.accessDesc": "Puedes ver, actualizar o eliminar tus datos guardados (ej. notas) directamente dentro de la app.",
      "privacy.section5.withdraw": "Retirar Consentimiento:",
      "privacy.section5.withdrawDesc": "Puedes deshabilitar los permisos de ubicación en cualquier momento a través de la configuración de tu dispositivo.",
      "privacy.section5.deletion": "Eliminación de Datos:",
      "privacy.section5.deletionDesc": "Para eliminar todos los datos almacenados localmente, puedes borrar los datos de la app o reinstalarla.",
      "privacy.section5.outro": "Si tienes inquietudes, por favor contáctanos como se indica a continuación.",

      "privacy.section6.title": "6. Privacidad de Niños",
      "privacy.section6.text": "Nuestra app no está destinada a niños menores de 13 años. No recopilamos intencionalmente información personal de niños. Si nos enteramos de tal recopilación, la eliminaremos inmediatamente.",

      "privacy.section7.title": "7. Cambios a Esta Política de Privacidad",
      "privacy.section7.text": "Podemos actualizar esta Política de Privacidad ocasionalmente para reflejar cambios en nuestras prácticas o por razones legales. Te notificaremos de cambios significativos actualizando la fecha de vigencia y, si es necesario, solicitándote dentro de la app.",

      "privacy.section8.title": "8. Declaración de Servicio Independiente",
      "privacy.section8.intro": "Oasis Oakland opera como una plataforma independiente de recursos comunitarios. No estamos afiliados, respaldados ni asociados formalmente con ninguna de las organizaciones, proveedores de atención médica, clínicas dentales, bancos de alimentos, instituciones educativas o proveedores de seguros presentados en nuestro directorio.",
      "privacy.section8.details": "Nuestro papel es servir como un recurso informativo, conectando a los miembros de la comunidad con servicios disponibles públicamente. Todos los servicios listados son operados independientemente por sus respectivas organizaciones. Verificamos la información lo mejor que podemos, pero la disponibilidad del servicio, los requisitos de elegibilidad y los horarios de operación son determinados en última instancia por cada proveedor individual.",
      "privacy.section8.responsibility": "Los usuarios deben confirmar los detalles directamente con los proveedores de servicios antes de visitarlos. Oasis Oakland no es responsable de la calidad, disponibilidad o resultados de los servicios proporcionados por las organizaciones listadas.",

      "privacy.section9.title": "9. Contáctanos",
      "privacy.section9.intro": "Si tienes alguna pregunta sobre esta Política de Privacidad o nuestras prácticas de datos, por favor contáctanos en:",
      "privacy.section9.email": "Correo:",

      "privacy.agreement": "Al usar Oasis Oakland, aceptas esta Política de Privacidad. Si no estás de acuerdo, por favor deja de usar la app.",

      // Footer
      "footer.about": "Acerca de",
      "footer.contact": "Contacto",
      "footer.legal": "Legal",
      "footer.mission": "Nuestra Misión",
      "footer.whoWeServe": "A Quién Servimos",
      "footer.privacyPolicy": "Política de Privacidad",
      "footer.tagline": "Conectándote con servicios comunitarios esenciales",
      "footer.copyright": "2025 Oasis Oakland. Todos los derechos reservados.",
      "footer.madeWith": "Hecho con ❤️ para la comunidad de Oakland",
    }
  },
  zh: {
    translation: {
      // 导航
      "nav.home": "首页",
      "nav.services": "服务",
      "nav.features": "功能",
      "nav.privacy": "隐私",
      "nav.tagline": "社区资源中心",
      "nav.closeMenu": "关闭菜单",
      "nav.openMenu": "打开菜单",
      "nav.goHome": "前往 Oasis Oakland 首页",

      // 主页区域
      "hero.title": "连接您与重要的",
      "hero.titleHighlight": "社区服务",
      "hero.subtitle": "在奥克兰获取免费且可负担的医疗、食品、教育等服务 — 无需登录，提供3种语言",
      "hero.ctaGooglePlay": "即将登陆 Google Play",
      "hero.ctaAppStore": "App Store（稍后推出）",
      "hero.googlePlayLabel": "立即下载",
      "hero.googlePlayStore": "Google Play",
      "hero.badgeFree": "100%免费",
      "hero.badgeNoLogin": "无需登录",
      "hero.badgeLanguages": "3种语言",
      "hero.notifyButton": "获取发布通知",
      "hero.floatingHealth": "医疗",
      "hero.floatingFood": "食品",
      "hero.floatingEducation": "教育",
      "hero.imageAlt": "Oasis Oakland - 社区资源",

      // 使命区域
      "mission.title": "我们的使命",
      "mission.text": "我们的使命是让奥克兰和阿拉米达县的每个人都能获得基本服务。无论您是在寻找免费医疗、可负担的牙科护理、食品援助、保险支持还是扫盲项目，我们的应用都能在一个易于使用的平台上将您连接到值得信赖的本地资源。无需登录，没有混淆——只有真正的帮助，快速到达。",

      // Oasis是什么区域
      "what.badge": "关于应用",
      "what.title": "Oasis Oakland 是什么？",
      "what.subtitle": "一站式在本地找到经过核实的社区支援",
      "what.description": "Oasis Oakland 是一款独立的多语言应用，收录超过 24 个可信赖的健康、食品、教育、保险与牙科服务，覆盖奥克兰及阿拉米达县。我们定期更新资讯，让您无需建立账户或支付费用即可联系到合适的帮助。",

      "what.solutionTitle": "应用内容",
      "what.solution1": "在同一个目录查看地点、类别与资格说明。",
      "what.solution2": "随时在英语、西班牙语与中文之间即时切换。",
      "what.solution3": "提前掌握营业时间、联系方法与所需文件。",

      "what.stat1": "已核实资源",
      "what.stat2": "支持语言",
      "what.stat3": "服务类别",
      "what.stat4": "永久免费",

      // 原因区域
      "why.title": "为什么奥克兰需要 Oasis",
      "why.fragmented.title": "信息分散",
      "why.fragmented.problem": "资源分散在多个网站、传单和电话线上",
      "why.fragmented.solution": "Oasis 解决方案：",
      "why.fragmented.answer": "一切集中在一个应用中",
      "why.language.title": "语言障碍",
      "why.language.problem": "大多数官方服务仅提供英语",
      "why.language.answer": "全面支持英语、西班牙语和普通话",
      "why.complex.title": "复杂导航",
      "why.complex.problem": "令人困惑的官僚系统让人望而却步",
      "why.complex.answer": "简单界面，无术语，无需注册",

      // 服务区域
      "services.title": "我们连接的服务",
      "services.subtitle": "5个基本类别的可信资源",
      "services.health.title": "医疗",
      "services.health.item1": "初级保健、疫苗接种、心理健康",
      "services.health.item2": "免费和滑动收费诊所",
      "services.health.item3": "Medi-Cal 和 Medicare 援助",
      "services.dental.title": "牙科",
      "services.dental.item1": "清洁、补牙、紧急牙科",
      "services.dental.item2": "儿童牙科",
      "services.dental.item3": "滑动收费选项",
      "services.literacy.title": "扫盲",
      "services.literacy.item1": "ESL 课程、GED 备考",
      "services.literacy.item2": "职业培训项目",
      "services.literacy.item3": "数字扫盲课程",
      "services.food.title": "食品",
      "services.food.item1": "食品银行和储藏室",
      "services.food.item2": "热食项目",
      "services.food.item3": "CalFresh (SNAP) 注册",
      "services.insurance.title": "保险",
      "services.insurance.item1": "Covered California 注册",
      "services.insurance.item2": "Medi-Cal 援助",
      "services.insurance.item3": "计划比较帮助",

      // 功能区域 (Bento Grid)
      "featuresSection.title": "您需要的一切，尽在一处",
      "featuresSection.subtitle": "从医疗诊所到法律援助，Oasis Oakland 将您与所需的服务连接起来。由社区推动，为社区服务。",
      "featuresSection.findResources.title": "轻松查找资源",
      "featuresSection.findResources.desc": "通过我们的互动地图，找到您附近的食品银行、庇护所、医疗诊所和法律援助服务。",
      "featuresSection.verifiedLocations.title": "已验证的地点",
      "featuresSection.verifiedLocations.desc": "我们验证每个地点，确保您获得准确、最新的信息。",
      "featuresSection.smartFiltering.title": "智能筛选",
      "featuresSection.smartFiltering.desc": "按类别、距离和营业状态快速筛选结果，找到您确切需要的服务。",
      "featuresSection.alwaysAvailable.title": "全天候可用",
      "featuresSection.alwaysAvailable.desc": "全天候访问重要信息。无需登录，没有任何障碍。",

      // 功能区域 (旧)
      "features.title": "主要功能",
      "features.subtitle": "为您精心设计",
      "features.noLogin.title": "无需登录",
      "features.noLogin.desc": "立即寻找帮助 - 无需账户、无需邮箱、完全隐私",
      "features.filtering.title": "智能筛选",
      "features.filtering.desc": "根据您的收入水平只看到您有资格获得的服务",
      "features.hours.title": "实时营业时间",
      "features.hours.desc": "在访问前了解某个地方现在是否开放",
      "features.maps.title": "地图和列表视图",
      "features.maps.desc": "通过交互式地图找到您附近的服务",
      "features.call.title": "拨打和导航",
      "features.call.desc": "一键拨打电话和获取任何服务的路线",
      "features.favorites.title": "保存收藏",
      "features.favorites.desc": "为快速访问收藏服务",

      // 如何运作区域
      "how.title": "如何运作",
      "how.subtitle": "寻求帮助不应该复杂",
      "how.noLogin.title": "无需登录",
      "how.noLogin.desc": "打开应用即可立即开始寻找资源 — 无需账户，没有障碍",
      "how.hours.title": "查看现在开放的服务",
      "how.hours.desc": "出发前检查实时营业时间，避免白跑一趟",
      "how.maps.title": "地图和列表视图",
      "how.maps.desc": "在地图或列表上浏览服务 — 选择最适合您的方式",
      "how.languages.title": "3种语言",
      "how.languages.desc": "即时在英语、西班牙语和普通话之间切换",

      // 服务对象区域（与服务覆盖合并）
      "who.badge": "奥克兰和阿拉米达县",
      "who.title": "我们服务的对象",
      "who.subtitle": "我们为整个社区服务，特别是最需要帮助的人",
      "who.item1": "寻找免费或可负担的医疗、食品和教育服务的家庭",
      "who.item2": "讲西班牙语和普通话的社区成员",
      "who.item3": "寻求Medicare信息、膳食和健康支持的老年人",
      "who.item4": "为孩子寻找护理和项目的父母",
      "who.note": "目前服务奥克兰和阿拉米达县，计划扩展。想在您的城市使用Oasis？告诉我们！",

      // 服务覆盖区域（保留以便向后兼容）
      "serving.badge": "服务奥克兰，加州",
      "serving.title": "目前服务奥克兰",
      "serving.text1": "Oasis Oakland 目前为奥克兰和阿拉米达县、加利福尼亚州提供服务。我们精心验证并绘制了24多个涵盖健康、牙科、食品、教育和保险服务的基本社区资源。",
      "serving.text2": "即将推出：",
      "serving.text3": "我们计划扩展到湾区和其他城市。如果您希望在您的社区中使用 Oasis，请联系我们！",

      // 语言区域
      "languages.title": "提供3种语言",
      "languages.english": "英语",
      "languages.spanish": "西班牙语",
      "languages.mandarin": "中文（普通话）",
      "languages.fullTranslation": "完整翻译",
      "languages.note": "在应用内即时切换语言 - 无需重启",

      // 通讯区域
      "newsletter.title": "Oasis Oakland 即将推出！",
      "newsletter.googlePlay": "Google Play",
      "newsletter.googlePlayDesc": "首先推出",
      "newsletter.appStore": "App Store",
      "newsletter.appStoreDesc": "之后推出",
      "newsletter.subtitle": "在我们在 Google Play 上推出时收到通知",
      "newsletter.placeholder": "输入您的邮箱",
      "newsletter.button": "通知我",
      "newsletter.note": "我们只会在应用准备好时给您发一次邮件。无垃圾邮件。",
      "newsletter.success": "🎉 成功！您已在列表中。",
      "newsletter.successDesc": "Oasis Oakland 在 Google Play 上推出后，我们会立即向您发送电子邮件。感谢您对帮助奥克兰社区的关注！",
      "newsletter.error": "哎呀！出了点问题。",
      "newsletter.errorDesc": "请稍后重试。如果问题仍然存在，请直接联系我们。",
      "newsletter.sending": "发送中...",

      // Beta 下载模态框
      "modal.title": "下载测试版",
      "modal.chooseVersion": "选择您的版本：",
      "modal.android": "Android",
      "modal.androidDesc": "从 Google Play 下载",
      "modal.web": "Web Beta",
      "modal.webDesc": "尝试网络版本",
      "modal.betaWarning": "这些链接仅适用于测试组成员",
      "modal.notInGroup": "还不在测试组？",
      "modal.enterEmail": "输入您的邮箱加入 beta 测试",
      "modal.joinBeta": "加入 Beta 计划",
      "modal.close": "关闭",
      "modal.emailPlaceholder": "输入您的邮箱",
      "modal.submitting": "发送中...",
      "modal.successTitle": "成功！",
      "modal.successMessage": "我们将向您发送加入测试计划的说明邮件。",
      "modal.errorTitle": "错误",
      "modal.errorMessage": "出错了，请重试。",

      // 隐私区域
      "privacy.title": "隐私政策",
      "privacy.transparent": "透明",
      "privacy.transparentDesc": "清楚说明我们收集什么以及为什么。",
      "privacy.localFirst": "本地优先",
      "privacy.localFirstDesc": "未经同意，您的信息永远不会离开您的设备。",
      "privacy.empowering": "赋权",
      "privacy.empoweringDesc": "工具可查看、更新或删除您共享的数据。",
      "privacy.intro": "感谢您使用 Oasis Oakland，这是一款旨在将您与奥克兰和阿拉米达县的基本社区服务联系起来的应用。您的隐私对我们很重要。本隐私政策解释了我们在您使用我们的应用时如何收集、使用和保护您的信息。",

      "privacy.section1.title": "1. 我们收集的信息",
      "privacy.section1.intro": "我们收集以下类型的信息以提供个性化服务推荐：",
      "privacy.section1.personal": "个人信息：",
      "privacy.section1.personalDesc": "在评估过程中，您可能会提供详细信息，如性别、就业状况、收入范围、语言偏好和居住城市。此信息是自愿提供的，有助于我们根据您的需求定制服务选项。这些数据永远不会离开应用，用于提供更适合用户的服务。",
      "privacy.section1.location": "位置数据：",
      "privacy.section1.locationDesc": "经您许可，我们访问您设备的位置以提供相关的附近服务和路线。这些数据在应用内本地使用，不会被存储或传输。",
      "privacy.section1.saved": "已保存的地方：",
      "privacy.section1.savedDesc": "您可以将地方保存到笔记中，这些笔记本地存储在您的设备上以方便使用。",
      "privacy.section1.outro": "所有数据都使用安全的本地存储机制在您的设备上收集和存储。我们不收集或存储敏感信息（如付款详细信息），因为我们的应用不处理交易。",

      "privacy.section2.title": "2. 我们如何使用您的信息",
      "privacy.section2.intro": "我们仅将收集的信息用于：",
      "privacy.section2.item1": "根据您的评估响应提供个性化的社区服务推荐。",
      "privacy.section2.item2": "启用基于位置的功能，如查找附近的服务或获取路线。",
      "privacy.section2.item3": "通过匿名分析改进应用的功能和用户体验。",
      "privacy.section2.item4": "允许您保存和管理有关地方的笔记。",
      "privacy.section2.outro": "我们不将您的数据用于营销、广告或应用功能之外的任何其他目的。",

      "privacy.section3.title": "3. 共享您的信息",
      "privacy.section3.text": "我们不会与第三方共享、出售或传输您的个人信息。所有数据都保留在您的设备上，不会发送到外部服务器或与其他应用或服务共享。但是，如果您选择通过应用的共享功能共享某个地方，该操作由您设备的本机共享功能处理，并受收件人隐私惯例的约束。",

      "privacy.section4.title": "4. 数据安全",
      "privacy.section4.intro": "我们优先考虑您信息的安全：",
      "privacy.section4.item1": "数据使用加密存储（例如 AsyncStorage 与 Redux Persist）本地存储在您的设备上。",
      "privacy.section4.item2": "我们无法访问您的数据；它仅驻留在您的设备上。",
      "privacy.section4.item3": "我们建议通过密码、生物识别锁定和最新软件保护您的设备以保护您的信息。",

      "privacy.section5.title": "5. 您的权利",
      "privacy.section5.intro": "您对您的数据拥有以下权利：",
      "privacy.section5.access": "访问和控制：",
      "privacy.section5.accessDesc": "您可以直接在应用内查看、更新或删除已保存的数据（例如笔记）。",
      "privacy.section5.withdraw": "撤回同意：",
      "privacy.section5.withdrawDesc": "您可以随时通过设备设置禁用位置权限。",
      "privacy.section5.deletion": "数据删除：",
      "privacy.section5.deletionDesc": "要删除所有本地存储的数据，您可以清除应用的数据或重新安装应用。",
      "privacy.section5.outro": "如果您有疑虑，请按照以下方式联系我们。",

      "privacy.section6.title": "6. 儿童隐私",
      "privacy.section6.text": "我们的应用不适用于13岁以下的儿童。我们不会故意收集儿童的个人信息。如果我们发现此类收集，我们将立即删除。",

      "privacy.section7.title": "7. 本隐私政策的变更",
      "privacy.section7.text": "我们可能会偶尔更新本隐私政策以反映我们做法的变化或出于法律原因。我们将通过更新生效日期来通知您重大变更，必要时在应用内提示您。",

      "privacy.section8.title": "8. 独立服务声明",
      "privacy.section8.intro": "Oasis Oakland 作为独立的社区资源平台运营。我们与目录中列出的任何组织、医疗保健提供者、牙科诊所、食品银行、教育机构或保险提供者没有附属关系、认可或正式关联。",
      "privacy.section8.details": "我们的作用是作为信息资源，将社区成员与公开可用的服务联系起来。所有列出的服务均由其各自的组织独立运营。我们尽最大努力验证信息，但服务可用性、资格要求和营业时间最终由每个单独的提供者决定。",
      "privacy.section8.responsibility": "用户应在访问前直接与服务提供者确认详细信息。Oasis Oakland 不对所列组织提供的服务的质量、可用性或结果负责。",

      "privacy.section9.title": "9. 联系我们",
      "privacy.section9.intro": "如果您对本隐私政策或我们的数据做法有任何疑问，请联系我们：",
      "privacy.section9.email": "电子邮件：",

      "privacy.agreement": "使用 Oasis Oakland，即表示您同意本隐私政策。如果您不同意，请停止使用该应用。",

      // 页脚
      "footer.about": "关于",
      "footer.contact": "联系",
      "footer.legal": "法律",
      "footer.mission": "我们的使命",
      "footer.whoWeServe": "我们服务的对象",
      "footer.privacyPolicy": "隐私政策",
      "footer.tagline": "连接您与重要的社区服务",
      "footer.copyright": "2025 Oasis Oakland。保留所有权利。",
      "footer.madeWith": "用 ❤️ 为奥克兰社区制作",
    }
  }
};

/**
 * Detects the browser/device language and maps it to supported languages
 * Works on iOS Safari, Android Chrome, and all modern browsers
 * @returns {string} Language code ('en', 'es', or 'zh')
 */
const detectBrowserLanguage = (): string => {
  try {
    // Get browser language (works on iOS, Android, Desktop)
    // navigator.language returns codes like: 'en-US', 'es-MX', 'zh-CN', etc.
    const browserLang = navigator.language || (navigator as any).userLanguage;

    if (!browserLang) {
      return 'en'; // fallback to English
    }

    // Extract the primary language code (e.g., 'en' from 'en-US')
    const primaryLang = browserLang.toLowerCase().split('-')[0];

    // Map to supported languages
    switch (primaryLang) {
      case 'es': // Spanish
        return 'es';
      case 'zh': // Chinese (Mandarin, Cantonese, etc.)
        return 'zh';
      case 'en': // English
      default:
        return 'en';
    }
  } catch (error) {
    console.warn('Language detection failed, defaulting to English:', error);
    return 'en';
  }
};

// Detect and set initial language
const initialLanguage = detectBrowserLanguage();

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage, // Use detected language instead of hardcoded 'en'
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
